<template>
  <div class="left_block course-create">
    <p class="header">
      <router-link :to="'/all-courses'">
        <span> Все курсы <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      Конструктор курса
    </p>

    <div class="creation_form">
      <CourseCreateFilter
        @change-photo="changePhoto"
        :disable-buttons="true"
        @click="openCategoriesModal"
        :fields-changed="fieldsChanged"
        :categories-list="categoriesList"
        @create="createCourse"
        :new-course="newCourse"
        @submit="addStage"
        @abort="abortStage"
        :new-stage="newStage"
      />

      <b-modal :active.sync="isModalOpen" has-modal-card scroll="keep" @close="closeCategoriesModal">
        <CategoriesModal @close-modal="closeCategoriesModal" />
      </b-modal>

      <b-modal :active.sync="isLeaveModalOpen" has-modal-card scroll="keep">
        <LeaveModal />
      </b-modal>
    </div>
  </div>
</template>

<script>
import CourseCreateFilter from '@/components/admin/all-courses/CourseCreateFilter'
import CategoriesModal from '@/components/admin/categories/CategoriesModal'
import LeaveModal from '@/components/modal/LeaveModal'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    CourseCreateFilter,
    CategoriesModal,
    LeaveModal
  },
  data() {
    return {
      isLeaveModalOpen: false,
      isModalOpen: false,
      fieldsChanged: {
        leaveAllowed: true
      },
      newCourse: {
        name: '',
        description: '',
        category_id: null,
        days_limit: 1,
        status: 0
      },
      newStage: {
        type: null,
        name: '',
        duration: 0,
        author: this.$store.state.auth.currentUser,
        course_id: null,
        content: 'test'
      },
      uploadedImage: null
    }
  },
  methods: {
    loadMainCategories() {
      this.$axios2
        .get('categories')
        .then((resp) => {
          this.$store.commit('setCategoriesList', { list: resp.data })
          this.$axios2
            .get('courses/list?category_id=' + resp.data[0].id)
            .then((response) => {
              this.$store.commit('setCategoryCoursesList', {
                list: response.data,
                index: 0
              })
            })
            .catch(this.$errorToast)
        })
        .catch(this.$errorToast)
      this.$axios2
        .get('categories?all=true')
        .then((resp) => {
          this.$store.commit('setModalCategoriesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    openCategoriesModal() {
      this.isModalOpen = true
    },
    closeCategoriesModal() {
      this.isModalOpen = false
    },
    changePhoto(file) {
      this.uploadedImage = file
    },
    createCourse() {
      let request = {}
      if (this.uploadedImage) {
        request = new FormData()
        request.append('image', this.uploadedImage)
        Object.keys(this.newCourse).forEach((key) => {
          request.append(key, this.newCourse[key])
        })
      } else {
        request = this.newCourse
      }
      this.$axios2
        .post('courses', request, this.uploadedImage ? { headers: { 'content-type': 'multipart/form-data' } } : '')
        .then((resp) => {
          this.loadMainCategories()
          this.$buefy.toast.open(toastInfo())
          this.$router.push('/all-courses/create/' + resp.data.id)
        })
        .catch(this.$errorToast)
    },
    abortStage() {
      this.newStage = {
        type: null,
        name: '',
        time: null,
        author: this.$store.state.auth.currentUser,
        course_id: null
      }
    },
    addStage() {
      let request = {}
      if (this.uploadedImage) {
        request = new FormData()
        request.append('image', this.uploadedImage)
        Object.keys(this.newCourse).forEach((key) => {
          request.append(key, this.newCourse[key])
        })
      } else {
        request = this.newCourse
      }
      this.$axios2
        .post('courses', request, this.uploadedImage ? { headers: { 'content-type': 'multipart/form-data' } } : '')
        .then((res) => {
          this.$router.push('/all-courses/create/' + res.data.id)
          this.loadMainCategories()
          this.$buefy.toast.open(toastInfo())
          this.$axios2
            .post('courses/' + res.data.id + '/stages', {
              sort_number: 0,
              name: this.newStage.name,
              type: this.newStage.type,
              description: 'Описание'
            })
            .then(() => {
              this.$buefy.toast.open(toastInfo())
            })
            .catch(this.$errorToast)
        })
        .catch(this.$errorToast)
    }
  },
  mounted() {
    window.onbeforeunload = function () {
      return 'Вы собираетесь покинуть страницу? Возможно, внесенные изменения не сохранятся!'
    }
  },
  beforeDestroy() {
    window.onbeforeunload = ''
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'all-courses_create_id' || this.fieldsChanged.leaveAllowed) {
      next()
      return
    }
    this.isLeaveModalOpen = true
    this.$nextTick(() => {
      document.getElementById('confirm-leave-btn').addEventListener('click', () => {
        this.isLeaveModalOpen = false
        next()
      })
      document.getElementById('abort-leave-btn').addEventListener('click', () => {
        this.isLeaveModalOpen = false
        next(false)
      })
    })
  },
  computed: {
    categoriesList() {
      return this.$store.state.categories.ModalCategoriesList
    }
  }
}
</script>
